import {CalculatorService} from "app/components/calculator/calculator.services";
import {calculatorPublisherInit} from "app/components/calculator/publisher/calculatorPublisher";
import {INIT_CALCULATOR} from "reducers/calculator";
import {getCookie} from "app/lib/cookies";
import {CALCULATOR_COOKIE_NAME} from "app/services/calculatorCookieService";
import {CalculatorProvider} from "./calculator.provider";
import {CalculatorActions} from "actions/calculatorActions";
import {CalculatorCookieService} from "app/services/calculatorCookieService";
import {calculatorGeoDefinitions} from "./helpers/calculatorGeoDefinitions";
import {mapKeys, camelCase} from 'lodash';

class CalculatorInitializerController {
    constructor(dispatch, getState) {
        this.dispatch = dispatch;
        this.getState = getState;
        this.actions = CalculatorActions();
    }

    async invoke() {
        const predefinedCookie = this.resolvePredefinedCookie();
        const geolocation = window.geolocation;

        if (predefinedCookie && window.isHomepage) {
            this.setBaseIntoPredefinedTransfer(predefinedCookie);
        } else if (geolocation && window.isHomepage) {
            this.setBaseDefinedByGeolocation(geolocation);
        }

        await this.validateBaseDirection();
        await this.initializeDefault();
        this.dispatch({type: INIT_CALCULATOR})
    }

    /** @private */
    async initializeDefault() {
        const service = new CalculatorService(this.dispatch);

        await this.dispatch(this.actions.loadAvailableDirectionsAction());
        await this.dispatch(this.actions.loadAvailableCurrenciesAction());
        await this.dispatch(this.actions.getExchangeRateAction());

        const state = this.getState().calculator;
        service.calculateAmount(state, 'amountIn');

        await this.dispatch(this.actions.loadAvailableDeliveryMethodsAction());
        service.updateCookies(this.getState().calculator);
        calculatorPublisherInit(this.getState().calculator);
    }

    /** @private */
    resolvePredefinedCookie() {
        const predefinedTransferCookie = getCookie(CALCULATOR_COOKIE_NAME);
        const cookiePayload = predefinedTransferCookie && CalculatorCookieService
            .read(predefinedTransferCookie, CALCULATOR_COOKIE_NAME);

        return cookiePayload && mapKeys(cookiePayload, (v, k) => camelCase(k))
    }

    /** @private */
    setBaseIntoPredefinedTransfer(predefined) {
        CalculatorProvider.update({
            amountIn: predefined.amountIn,
            countryIn: predefined.countryFrom,
            countryOut: predefined.countryTo,
            currencyIn: predefined.currencyIn,
            currencyOut: predefined.currencyOut,
            product: predefined.realizationMethod
        });
    }

    /** @private */
    setBaseDefinedByGeolocation(location) {
        const definition = calculatorGeoDefinitions(location);
        CalculatorProvider.update(definition);
    }

    /** @private */
    async validateBaseDirection() {
        await this.dispatch(this.actions.loadAvailableDirectionsAction());
        const state = this.getState().calculator;
        if (
            !state.directions ||
            !state.directions[state.countryIn] ||
            !state.directions[state.countryIn].includes(state.countryOut)
        ) {
            // Fallback direction
            CalculatorProvider.update({
                amountIn: 50000,
                countryIn: 'GB',
                countryOut: 'PL',
                currencyIn: 'GBP',
                currencyOut: 'PLN',
                product: 'fast'
            });
        }
    }
}

export const CalculatorInitializer = (dispatch, getState) => {
    const initializer = new CalculatorInitializerController(dispatch, getState);

    return initializer.invoke();
};
